const navbar: HTMLHeadElement = document.querySelector('.navbar');

if (navbar) {
    const navbarUser = navbar.querySelector('.navbar__user') as HTMLDivElement;
    const navbarUserDropdown = navbar.querySelector('.navbar__user-dropdown') as HTMLUListElement;
    const linkItems: NodeListOf<HTMLLIElement> = navbar.querySelectorAll('.navbar__links-drop');

    const checkScrollPosition = () => {
        if (window.scrollY === 0) {
            navbar.classList.remove('navbar--sticky');
        } else {
            navbar.classList.add('navbar--sticky');
        }
    };

    if (navbarUser) {
        navbarUser.addEventListener('click', (event: MouseEvent) => {
            event.stopPropagation();
            navbarUserDropdown.classList.toggle('navbar__user-dropdown--active');
        });

        navbarUser.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                event.stopPropagation();
                navbarUserDropdown.classList.toggle('navbar__user-dropdown--active');
            }
        });
    }

    linkItems.forEach((link) => {
        const href: string = link.getAttribute('data-url');

        link.addEventListener('click', () => {
            if (href) {
                window.location.href = href;
            }
        });

        link.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter' && href) {
                window.location.href = href;
            }
        });
    });

    window.addEventListener('scroll', checkScrollPosition);

    checkScrollPosition();
}
